import MetricBase from "models/metrics/MetricBase";
import i18n from "i18next";
import CurrencyUnit from "models/metrics/unit/CurrencyUnit";
import ConversionGroup from "../../../../groups/ConversionGroup";

class MetricRevenuePerclick extends MetricBase {
    constructor() {
        super({
            field: "metric_revenue_per_click",
            defaultVisibility: false,
            unit: CurrencyUnit,
            chartName: i18n.t("metrics.tripadvisor.revenue_perclick.chartName"),
            serieLabel: i18n.t("metrics.tripadvisor.revenue_perclick.serieLabel"),
            tooltip: i18n.t("metrics.tripadvisor.revenue_perclick.tooltip"),
            group: new ConversionGroup(),
        });
    }
}

export default MetricRevenuePerclick;